import {Grid, Typography} from "@mui/material";
import {DecimalFormField} from "./DecimalFormField";
import {FormulaSlider} from "./FormulaSlider";
import * as React from "react";
import {fdTheme} from "../../App";
import {adjustBrightness, getHexColor} from "../utils/ColorUtils";

function FormulaSliderEditor(props) {
  const {disabled, displayLabel, fieldName, fieldValue, auxFieldName, auxFieldValue, auxDisplayLabel, fieldContainer,
    onChangeFn, valueDisplayFn, updateFn, sliderColor, minVal, maxVal, sliderMinVal, sliderMaxVal, sliderStep, disableNumericEdit} = props;

  function onValueDisplayFormat(val, ix) {
    if (valueDisplayFn !== undefined) {
      return valueDisplayFn(val)
    }
    return `${fieldValue}`
  }

  function onNumericFieldChange(evt) {
    let intVal = parseInt(evt.target.value)
    if (isNaN(intVal)) {
      intVal = 0
    }
    updateFn({
      ...fieldContainer,
      [fieldName]: intVal
    })
  }

  function onDecimalChange(fieldName, fieldValue) {
    updateFn({...fieldContainer, [fieldName]: fieldValue})
  }

  function getThumbColor() {
    if (disabled) {
      return
    }
    let colorHex
    if (Object.hasOwn(fdTheme.palette, sliderColor)) {
      colorHex = fdTheme.palette[sliderColor].main;
    } else {
      colorHex = getHexColor(sliderColor);
    }
    if (colorHex === undefined) {
      return sliderColor
    }
    // thumb is lightened or darkened for a visual cue if the numeric field was manually entered outside the slider range
    if (fieldValue > sliderMaxVal) {
      // make it darker
      colorHex = adjustBrightness(colorHex, 60)
    } else if (fieldValue < sliderMinVal) {
      // make it lighter
      colorHex = adjustBrightness(colorHex, -60)
    }
    return colorHex
  }

  return (
          <Grid item container direction={'column'}>
            <Grid item container direction={'row'}>
              <Typography variant={'subtitle2'} gutterBottom>{displayLabel}
                {! disableNumericEdit ? (
                  <DecimalFormField disabled={disabled} value={fieldValue} sx={{"& .MuiInputBase-input": { fontSize: 14, height: 8, padding: 1}, marginTop: -0.25, marginLeft: 1, width: '8ch'}}
                                    name={fieldName} minVal={minVal} maxVal={maxVal} onChange={onDecimalChange}/>
                ) : null}
              </Typography>
              {auxFieldName ? (
                <Typography marginLeft={1} variant={'subtitle2'} gutterBottom>{auxDisplayLabel}
                  <DecimalFormField disabled={disabled} value={auxFieldValue} sx={{"& .MuiInputBase-input": { fontSize: 14, height: 8, padding: 1}, marginTop: -0.25, marginLeft: 1, width: '8ch'}}
                                    name={auxFieldName} minVal={minVal} maxVal={maxVal} onChange={onDecimalChange}/>
                </Typography>
                ) : null}
            </Grid>
            <FormulaSlider getAriaLabel={() => displayLabel}
                           sx={{width: '90%', marginLeft: 1, marginTop: -1, pointerEvents: 'none !important', '.MuiSlider-thumb': {backgroundColor: getThumbColor(), pointerEvents: 'all !important'}}}
                           name={fieldName}
                           value={fieldValue}
                           disabled={disabled}
                           onChange={(evt) => onChangeFn !== undefined ? onChangeFn(evt) : onNumericFieldChange(evt)}
                           valueLabelDisplay="auto"
                           valueLabelFormat={onValueDisplayFormat}
                           color={sliderColor}
                           min={sliderMinVal}
                           max={sliderMaxVal}
                           step={sliderStep}/>
          </Grid>
  )
}


export {FormulaSliderEditor}